import React from "react";
import { Row, Col } from "react-bootstrap";
import {
  faBullseye,
  faChartLine,
  faUsers,
  faTrophy,
} from "@fortawesome/free-solid-svg-icons";
import StatsCard from "./StatsCard";
import { MetaResumida } from "../../../../types/meta";

interface StatsOverviewProps {
  totalTarget: number;
  totalAchieved: number;
  overallProgress: number;
  topPerformersCount: number;
  selectedMeta: MetaResumida | null;
}

export const StatsOverview: React.FC<StatsOverviewProps> = ({
  totalTarget,
  totalAchieved,
  overallProgress,
  topPerformersCount,
  selectedMeta,
}) => {
  const formatCurrency = (value: number) => {
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(value);
  };

  const getPeriodLabel = () => {
    if (!selectedMeta) return "Nenhuma meta selecionada";
    
    if (selectedMeta.dataInicio && selectedMeta.dataFim) {
      return `${new Date(selectedMeta.dataInicio).toLocaleDateString(
        "pt-BR"
      )} até ${new Date(selectedMeta.dataFim).toLocaleDateString("pt-BR")}`;
    }
    
    return "Período personalizado";
  };

  return (
    <Row className="mb-4">
      <Col md={3} className="mb-3">
        <div className="stats-card fade-in-up">
          <StatsCard
            title="Meta Total"
            value={formatCurrency(totalTarget)}
            subtitle={`Período ${getPeriodLabel()}`}
            icon={faBullseye}
          />
        </div>
      </Col>
      <Col md={3} className="mb-3">
        <div className="stats-card fade-in-up">
          <StatsCard
            title="Vendas Realizadas"
            value={formatCurrency(totalAchieved)}
            subtitle="Total atingido"
            icon={faChartLine}
          />
        </div>
      </Col>
      <Col md={3} className="mb-3">
        <div className="stats-card fade-in-up">
          <StatsCard
            title="Progresso Geral"
            value={`${Math.round(overallProgress)}%`}
            subtitle="Da meta total"
            icon={faUsers}
          />
        </div>
      </Col>
      <Col md={3} className="mb-3">
        <div className="stats-card fade-in-up">
          <StatsCard
            title="Top Performers"
            value={topPerformersCount}
            subtitle="Acima da meta"
            icon={faTrophy}
          />
        </div>
      </Col>
    </Row>
  );
};
